import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import SectionView from "../../../layout/section/SectionView";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {updateBillOfMaterialsAssetSellPrice} from "../../../../store/action/billOfMaterials/billOfMaterials";
import {connect} from "react-redux";
import {PriceApiDto} from "../../../../api/model/rest";
import SuggestedAssetPrice from "../../../../model/job/SuggestedAssetPrice";
import {BomItem} from "../../../../model/job/BomItems";

interface IComponentProps {
	/**
	 * On modal close
	 */
	closeModal: () => void;
	/**
	 * Bill of materials id
	 */
	bomDetailsId: string;
	/**
	 * Selected asset
	 */
	selectedAsset: BomItem;
	/**
	 * Suggested asset sell price
	 */
	suggestedAssetSellPrice: SuggestedAssetPrice;
	/**
	 * Job id
	 */
	jobId: string;
}

interface DispatchProps {
	/**
	 */
	updateBillOfMaterialsAssetSellPrice: (bomId: string, assetId: string, suggestedAssetSellPrice: PriceApiDto, jobId: string,
		onSuccess: OnSuccess, onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & DispatchProps;

class SuggestPriceModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isSubmitting: false
		};
		this.updateAssetSellPrice = this.updateAssetSellPrice.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.closeModal} title={'Cost of asset'} autoWidth={true}>
				<SectionView>
					<p>New suggested sell price for "<strong>{this.props.selectedAsset.name}</strong>"
						is <strong>{this.props.suggestedAssetSellPrice.sellPrice.format()}</strong></p>
					<p>You can confirm the price change or adjust the cost of the Asset manually.</p>
				</SectionView>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.closeModal}
									label={"Cancel"}
									disabled={this.state.isSubmitting}/>
					<ButtonPrimary onClick={this.updateAssetSellPrice}
								   label={"Update price"}
								   disabled={this.state.isSubmitting}
								   isLoading={this.state.isSubmitting}/>
				</FormButtonsView>
			</Modal>
		);
	}

	updateAssetSellPrice() {
		this.setState({isSubmitting: true}, () => {
			this.props.updateBillOfMaterialsAssetSellPrice(this.props.bomDetailsId,
				this.props.selectedAsset.id,
				this.props.suggestedAssetSellPrice.sellUnitPrice.toJson(), this.props.jobId,
				() => {
					this.props.closeModal();
					Toast.success('Asset sell price updated', 'Asset sell price update');
				},
				(error) => {
					this.setState({isSubmitting: false});
					notifyBugsnagAndShowToast(error, 'Update asset sell price')
				});
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateBillOfMaterialsAssetSellPrice: (bomId: string, assetId: string, suggestedAssetSellPrice: PriceApiDto, jobId: string,
			onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateBillOfMaterialsAssetSellPrice(bomId, assetId, suggestedAssetSellPrice, jobId, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(SuggestPriceModal);